/* Cover My Plate · drawn-hole check for the vanity + mini plate builders (needs cmp-bg-adjust.js).
   AI apps often draw mounting holes into a plate design. When a plate-shaped upload has holes drawn in,
   we try to line them up with the real holes (one zoom + move, with Undo). If they can't be lined up,
   the customer is told we'll clean them up on the proof. Either way the order gets a hidden _Drawn Holes note. */
(function () {
  'use strict';
  if (window.CMPHoles) return;
  var W = 640;

  function lum(i, w, h) {
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d'), A = window.CMPAdjust, p = A.place(i, { x: 0, y: 0, w: w, h: h }, null);
    g.drawImage(i, p.x, p.y, p.w, p.h);
    var d = g.getImageData(0, 0, w, h).data, L = new Float64Array((w + 1) * (h + 1)), Q = new Float64Array((w + 1) * (h + 1));
    for (var y = 0; y < h; y++) {
      var rs = 0, rq = 0;
      for (var x = 0; x < w; x++) {
        var k = (y * w + x) * 4, v = 0.299 * d[k] + 0.587 * d[k + 1] + 0.114 * d[k + 2];
        rs += v; rq += v * v;
        L[(y + 1) * (w + 1) + x + 1] = L[y * (w + 1) + x + 1] + rs;
        Q[(y + 1) * (w + 1) + x + 1] = Q[y * (w + 1) + x + 1] + rq;
      }
    }
    return { L: L, Q: Q, w: w, h: h };
  }
  function box(I, T, x0, y0, x1, y1) {
    x0 = Math.max(0, Math.round(x0)); y0 = Math.max(0, Math.round(y0)); x1 = Math.min(I.w, Math.round(x1)); y1 = Math.min(I.h, Math.round(y1));
    if (x1 <= x0 || y1 <= y0) return { s: 0, n: 0 };
    var W1 = I.w + 1;
    return { s: T[y1 * W1 + x1] - T[y0 * W1 + x1] - T[y1 * W1 + x0] + T[y0 * W1 + x0], n: (x1 - x0) * (y1 - y0) };
  }
  // best hole-like blob near (ex, ey): an even patch that stands out from the ring around it
  function find(I, ex, ey, sw, sh) {
    var best = null, rx = 0.11 * I.w, ry = 0.1 * I.h, step = 2;
    [0.8, 1, 1.3].forEach(function (f) {
      var w = sw * f, h = sh * f;
      for (var y = ey - ry; y <= ey + ry; y += step) for (var x = ex - rx; x <= ex + rx; x += step) {
        var a = box(I, I.L, x - w / 2, y - h / 2, x + w / 2, y + h / 2); if (!a.n) continue;
        var q = box(I, I.Q, x - w / 2, y - h / 2, x + w / 2, y + h / 2), m = a.s / a.n, sd = Math.sqrt(Math.max(0, q.s / q.n - m * m));
        var o = box(I, I.L, x - w, y - h, x + w, y + h), rn = o.n - a.n; if (rn <= 0) continue;
        var rm = (o.s - a.s) / rn, ct = Math.abs(m - rm), sc = ct - sd * 0.6;
        if (!best || sc > best.sc) best = { x: x, y: y, sc: sc, ct: ct, sd: sd };
      }
    });
    return best && best.ct > 24 && best.sd < 24 ? best : null;
  }

  function check(c, i) {
    var A = window.CMPAdjust, H = A.holes[c.kind]; c._drawnHoles = '';
    if (!H || !i) return;
    var s = [i.naturalWidth || i.width, i.naturalHeight || i.height], ar = s[0] / s[1], want = A.ar[c.kind];
    if (Math.abs(ar - want) / want > 0.12) return; // only plate-shaped uploads (square mockups are skipped)
    var w = W, h = Math.round(W / want), I;
    try { I = lum(i, w, h); } catch (e) { return; }
    var sw = H.w * w, sh = H.h * h, got = [];
    for (var a = 0; a < H.ys.length; a++) for (var b = 0; b < H.xs.length; b++) {
      var f = find(I, H.xs[b] * w, H.ys[a] * h, sw, sh);
      if (!f) return; // not every hole found: leave it alone
      got.push({ ex: H.xs[b], ey: H.ys[a], x: f.x / w, y: f.y / h });
    }
    // must look like a real hole pattern: mirrored left/right, matching rows
    var L = got.filter(function (g) { return g.ex < 0.5; }), R = got.filter(function (g) { return g.ex > 0.5; });
    var lx = avg(L, 'x'), rx = avg(R, 'x');
    if (Math.abs(lx + rx - 1) > 0.08 || rx - lx < 0.4) return;
    for (var q = 0; q < got.length; q += H.xs.length) if (Math.abs(got[q].y - got[q + 1].y) > 0.04) return; // each row level
    if (H.ys.length > 1 && (Math.abs(got[0].x - got[2].x) > 0.03 || Math.abs(got[1].x - got[3].x) > 0.03)) return; // columns straight
    var off = got.reduce(function (m, g) { return Math.max(m, Math.abs(g.x - g.ex), Math.abs(g.y - g.ey)); }, 0);
    if (off < 0.008) { c._drawnHoles = 'Holes drawn in the design already sit on the real holes.'; A.note(c, 'Your design has mounting holes drawn in. They already line up with the real holes.'); return; }
    var zx = (H.xs[1] - H.xs[0]) / (rx - lx), z = zx;
    if (H.ys.length > 1) {
      var T = got.filter(function (g) { return g.ey < 0.5; }), B = got.filter(function (g) { return g.ey > 0.5; }), zy = (H.ys[1] - H.ys[0]) / (avg(B, 'y') - avg(T, 'y'));
      if (Math.abs(zx - zy) / ((zx + zy) / 2) > 0.07) return fail(c);
      z = (zx + zy) / 2;
    }
    if (z < 0.85 || z > 1.3) return fail(c);
    var fx = avg(got, 'x'), fy = avg(got, 'y'), tx = avg(got, 'ex'), ty = avg(got, 'ey');
    var adj = { z: z, x: tx - (0.5 + (fx - 0.5) * z), y: ty - (0.5 + (fy - 0.5) * z) };
    A.set(c, adj);
    c._drawnHoles = 'Holes drawn in the design were lined up with the real holes (zoom ' + Math.round(z * 100) + '%). Check they line up on the proof.';
    A.note(c, 'We lined up the holes drawn in your design with the real mounting holes.<button type="button" data-cmph-undo>Undo</button>');
    var u = c.root.querySelector('[data-cmph-undo]');
    if (u) u.addEventListener('click', function () { A.set(c, { z: 1, x: 0, y: 0 }); c._drawnHoles = 'Holes drawn in the design. Customer chose not to line them up: clean them up on the proof.'; A.note(c, 'Got it. We\'ll clean up the drawn holes on your proof.'); });
  }
  function fail(c) {
    c._drawnHoles = 'Holes drawn in the design don\'t match the real holes: clean them up on the proof.';
    window.CMPAdjust.note(c, 'Your design has mounting holes drawn in. We\'ll clean them up on your proof, so they won\'t print.');
  }
  function avg(a, k) { return a.reduce(function (s, g) { return s + g[k]; }, 0) / a.length; }

  window.CMPHoles = { check: function (c, i) { try { check(c, i); } catch (e) {} } };
})();